import { render, staticRenderFns } from "./access.vue?vue&type=template&id=160139d1&scoped=true"
import script from "./access.vue?vue&type=script&lang=ts"
export * from "./access.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160139d1",
  null
  
)

export default component.exports